import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { LeagueDivisionsFiltersRequest } from '../../../models/leagues/requests/api-leagues-divisions-request.model';
import { LeaguesResultsResponse } from '../../../models/leagues/responses/api-leagues-results-response.model';
import { LeagueRewardsResultsResponse } from '../../../models/leagues/responses/api-league-rewards-results-response.model';
import { LeagueDivisionsResultsResponse } from '../../../models/leagues/responses/api-league-divisions-results-response.model';
import { LeagueDivisionUsersResultsResponse } from '../../../models/leagues/responses/api-league-division-users-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiLeaguesService {

  constructor(private apiService: ApiService) { }

  getLeagues(): Promise<LeaguesResultsResponse> {
    return new Promise<LeaguesResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.leaguesGetLeaguesUrl, LeaguesResultsResponse).then(
        (data: LeaguesResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addLeague(name: string, tier: number, leaguePreviousId: number, leagueNextId: number, freeCreditsBonus: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { name, tier, league_previous_id: leaguePreviousId, league_next_id: leagueNextId, free_credits_bonus_percent: freeCreditsBonus };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesAddLeagueUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editLeague(leagueId: number, name: string, tier: number, leaguePreviousId: number, leagueNextId: number, freeCreditsBonus: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { league_id: leagueId, name, tier, league_previous_id: leaguePreviousId, league_next_id: leagueNextId, free_credits_bonus_percent: freeCreditsBonus };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesEditLeagueUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteLeague(leagueId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesDeleteLeagueUrl, { league_id: leagueId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getLeaguesRewards(leagueId: number): Promise<LeagueRewardsResultsResponse> {
    return new Promise<LeagueRewardsResultsResponse>((resolve, reject) => {
      const body = { league_id: leagueId };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesGetLeaguesRewardsUrl, body, LeagueRewardsResultsResponse).then(
        (data: LeagueRewardsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addLeagueReward(leagueId: number, rank: number, currencyType: number, currencyQuantity: number, currencyTicketCost: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { league_id: leagueId, rank, currency_type: currencyType, currency_quantity: currencyQuantity, currency_ticket_cost: currencyTicketCost };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesAddLeagueRewardUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editLeagueReward(rewardId: number, rank: number, currencyType: number, currencyQuantity: number, currencyTicketCost: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { reward_id: rewardId, rank, currency_type: currencyType, currency_quantity: currencyQuantity, currency_ticket_cost: currencyTicketCost };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesEditLeagueRewardUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteLeagueReward(rewardId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesDeleteLeagueRewardUrl, { reward_id: rewardId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getLeaguesDivisions(page: number, resultCount: number, filters: LeagueDivisionsFiltersRequest): Promise<LeagueDivisionsResultsResponse> {
    return new Promise<LeagueDivisionsResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount, filters };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesGetLeaguesDivisionsUrl, body, LeagueDivisionsResultsResponse).then(
        (data: LeagueDivisionsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getLeagueDivisionUsers(divisionId: number): Promise<LeagueDivisionUsersResultsResponse> {
    return new Promise<LeagueDivisionUsersResultsResponse>((resolve, reject) => {
      const body = { division_id: divisionId };
      this.apiService.launchAdminApiRequestPost(apiUrls.leaguesGetLeagueDivisionUsersUrl, body, LeagueDivisionUsersResultsResponse).then(
        (data: LeagueDivisionUsersResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }
}
